/*
 * Collection filters: any change re-renders the section through the Section Rendering API
 * and updates the URL, so filtered pages stay shareable and the back button works.
 */
(function () {
  function init(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    const id = section.dataset.sectionId;
    let controller;

    async function render(url, push = true) {
      controller?.abort();
      controller = new AbortController();
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', id);
      section.classList.add('is-loading');
      try {
        const html = await (await fetch(u, { signal: controller.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-collection]');
        ['[data-results]', '[data-filter-form]'].forEach(sel => {
          const a = section.querySelector(sel), b = fresh && fresh.querySelector(sel);
          if (a && b) a.replaceWith(b);
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({ collection: true }, '', u);
        bind();
      } catch (e) {
        if (e.name !== 'AbortError') location.href = url;
      } finally {
        section.classList.remove('is-loading');
      }
    }

    function formUrl() {
      const form = section.querySelector('[data-filter-form]');
      const params = new URLSearchParams();
      if (form) new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      const sort = section.querySelector('[data-sort]');
      if (sort) params.set('sort_by', sort.value);
      return location.pathname + '?' + params.toString();
    }

    let debounce;
    function bind() {
      const form = section.querySelector('[data-filter-form]');
      if (form && !form.dataset.bound) {
        form.dataset.bound = '1';
        form.addEventListener('input', e => {
          clearTimeout(debounce);
          debounce = setTimeout(() => render(formUrl()), e.target.type === 'number' ? 600 : 0);
        });
        form.addEventListener('submit', e => { e.preventDefault(); render(formUrl()); });
      }
      const sort = section.querySelector('[data-sort]');
      if (sort && !sort.dataset.bound) {
        sort.dataset.bound = '1';
        sort.addEventListener('change', () => render(formUrl()));
      }
    }
    section.addEventListener('click', e => {
      const a = e.target.closest('[data-filter-link]');
      if (a) { e.preventDefault(); render(a.href); section.scrollIntoView({ block: 'start' }); }
    });
    addEventListener('popstate', () => render(location.href, false));

    // Mobile: filters panel as a drawer.
    const panel = section.querySelector('[data-filters]');
    const scrim = section.querySelector('[data-filters-scrim]');
    const setOpen = open => {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      scrim.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) panel.querySelector('button, input')?.focus();
    };
    section.addEventListener('click', e => {
      if (e.target.closest('[data-filters-open]')) setOpen(true);
      if (e.target.closest('[data-filters-close]') || e.target === scrim) setOpen(false);
    });
    section.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); });
    bind();
  }
  document.querySelectorAll('[data-collection]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-collection]').forEach(init));
})();
